import i18n from '@/lib/i18n'

export const ERROR_MESSAGE = {
  required: i18n.t('common.error.required'),
  invalid: i18n.t('common.error.invalid'),
  incorrect: i18n.t('common.error.incorrect'),
  noItem: i18n.t('common.error.noItem'),
  null: i18n.t('common.error.null'),
  status: i18n.t('common.error.status'),
  over: i18n.t('common.error.over'),
  sameAsNow: i18n.t('common.error.sameAsNow'),
} as const

export const STATUS_ERROR_MESSAGE = {
  504: i18n.t('common.error.statusCode.504'),
} as const

/** 400エラーのカスタムメッセージ */
export const OPERATIONAL_ERROR_MESSAGE = {
  ADDRESS: {
    SEARCH_BY_ZIP_CODE: i18n.t(
      'common.error.statusCode.400.address.searchByZipCode'
    ),
  },
  FAVORITE: {
    COPY: {
      ...ERROR_MESSAGE,
      expired: i18n.t('common.error.statusCode.400.favorite.copy.expired'),
      unavailable: i18n.t(
        'common.error.statusCode.400.favorite.copy.unavailable'
      ),
      forbidden: i18n.t('common.error.statusCode.400.favorite.copy.forbidden'),
    },
  },
  CART: {
    DELIVERY_DATE: {
      ...ERROR_MESSAGE,
      invalid: i18n.t('common.error.statusCode.400.cart.delivaryDate.invalid'),
      incorrect: i18n.t(
        'common.error.statusCode.400.cart.delivaryDate.incorrent'
      ),
    },
    ORDER: {
      ...ERROR_MESSAGE,
      noItem: i18n.t('common.error.statusCode.400.cart.order.noItem'),
      null: i18n.t('common.error.statusCode.400.cart.order.null'),
    },
  },
  ORDER: {
    // RETURN_TO_CART: {
    //   ...ERROR_MESSAGE,
    //   status: `${ORDER_TITLE}の${SHIPPING_INFORMATION_TITLE_SHORT}ステータスが未${SHIPPING_INFORMATION_TITLE_SHORT}でありません`,
    //   invalid: `${ORDER_HISTORY_FIELDS.orderNo}が不正な値です`,
    // },
    DELIVERY_DATE: {
      ...ERROR_MESSAGE,
      over: i18n.t('common.error.statusCode.400.order.deliveryDate.over'),
    },
  },
  USER: {
    CHANGE_EMAIL: {
      sameAsNow: i18n.t(
        'common.error.statusCode.400.user.changeEmail.sameAsNow'
      ),
    },
  },
}

export const ERROR_FIELD_NAMES = {
  // 商品関連
  itemCode: i18n.t('common.error.field.itemCode'),
  groupId: i18n.t('common.error.field.groupId'),
  salonPriceLower: i18n.t('common.error.field.salonPriceLower'),
  salonPriceUpper: i18n.t('common.error.field.salonPriceUpper'),
  retailPriceLower: i18n.t('common.error.field.retailPriceLower'),
  retailPriceUpper: i18n.t('common.error.field.retailPriceUpper'),
  brandCodes: i18n.t('common.error.field.brandCodes'),
  categoryIds: i18n.t('common.error.field.categoryIds'),
  salesStartFrom: i18n.t('common.error.field.salesStartFrom'),
  salesStartTo: i18n.t('common.error.field.salesStartTo'),
  keywords: i18n.t('common.error.field.keywords'),
  lineupCode: i18n.t('common.error.field.lineupCode'),
  // 発注関連
  orderNo: i18n.t('common.error.field.orderNo'),
  deliveryDateFrom: i18n.t('common.error.field.deliveryDateFrom'),
  deliveryDateTo: i18n.t('common.error.field.deliveryDateTo'),
  shipmentStatus: i18n.t('common.error.field.shipmentStatus'),
  approvalStatus: i18n.t('common.error.field.approvalStatus'),
  salesOrderNo: i18n.t('common.error.field.salesOrderNo'),
  // お気に入り関連
  setNo: i18n.t('common.error.field.setNo'),
  // カート関連
  address1: i18n.t('common.error.field.address1'),
  address2: i18n.t('common.error.field.address2'),
  deliveryDate: i18n.t('common.error.field.deliveryDate'),
  zipCode: i18n.t('common.error.field.zipCode'),
  tel: i18n.t('common.error.field.tel'),
  deliveryName: i18n.t('common.error.field.deliveryName'),
  desiredDeliveryDate: i18n.t('common.error.field.desiredDeliveryDate'),
  // 注文取込関連
  systemType: i18n.t('common.error.field.systemType'),
  orderDateFrom: i18n.t('common.error.field.orderDateFrom'),
  fileContent: i18n.t('common.error.field.fileContent'),
  fileName: i18n.t('common.error.field.fileName'),
  fileId: i18n.t('common.error.field.fileId'),
  // 請求書関連
  invoiceId: i18n.t('common.error.field.invoiceId'),
  // 共通
  storeCode: i18n.t('common.error.field.storeCode'),
  page: i18n.t('common.error.field.page'),
  pageSize: i18n.t('common.error.field.pageSize'),
}
